import CorporateCommunicated from '../interfaces/CorporateCommunicated';

export const INITIAL_VALUES: CorporateCommunicated = {
  Assunto: '',
  LinkDetalhe: '',
  ImagemDetalhe: '',
  TextoDetalhe: '',
  Tipo: '',
  DataInicio: '',
  DataFim: '',
  TextButton: 0,
  Publico: 0,
  GrupoId: []
}
